"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _menu = _interopRequireDefault(require("./utils/menu"));

require("./FoodMenuCategoryNavigation.css");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var MenuCategoryNavigation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuCategoryNavigation, _React$Component);

  var _super = _createSuper(MenuCategoryNavigation);

  function MenuCategoryNavigation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuCategoryNavigation);
    _this = _super.call(this, props);
    _this.state = {
      activeItem: 0,
      selectedCategory: null
    };
    _this.getScheduleCategories = _this.getScheduleCategories.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onItemClick = _this.onItemClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getDropdownOptions = _this.getDropdownOptions.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSelectCategory = _this.onSelectCategory.bind((0, _assertThisInitialized2["default"])(_this));
    _this.smoothScroll = _this.smoothScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onScroll = _this.onScroll.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuCategoryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          parentId = _this$props.parentId,
          disabledAutoScrollDetection = _this$props.disabledAutoScrollDetection;

      if (typeof document !== "undefined" && !disabledAutoScrollDetection) {
        var container = document.getElementById(parentId);
        container.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          parentId = _this$props2.parentId,
          disabledAutoScrollDetection = _this$props2.disabledAutoScrollDetection;

      if (typeof document !== "undefined" && !disabledAutoScrollDetection) {
        var container = document.getElementById(parentId);
        container.removeEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "getScheduleCategories",
    value: function getScheduleCategories() {
      var _this$props3 = this.props,
          scheduleId = _this$props3.scheduleId,
          schedules = _this$props3.schedules,
          categories = _this$props3.categories;

      var schedule = _menu["default"].getScheduleById(schedules, scheduleId);

      var scheduleCategoryIds = schedule.categories;
      return _menu["default"].getScheduleCategories(scheduleCategoryIds, categories);
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(e) {
      this.smoothScroll(e);
    }
  }, {
    key: "getDropdownOptions",
    value: function getDropdownOptions() {
      return this.getScheduleCategories().map(function (_ref) {
        var name = _ref.name;
        return {
          key: name,
          value: name,
          text: name,
          as: 'a',
          href: "#".concat(name)
        };
      });
    }
  }, {
    key: "smoothScroll",
    value: function smoothScroll(e) {
      e.preventDefault();

      if (typeof document !== "undefined") {
        var _this$props4 = this.props,
            scrollOffset = _this$props4.scrollOffset,
            parentId = _this$props4.parentId;
        var id = e.currentTarget.getAttribute('href').slice(1);
        var anchor = document.getElementById(id);
        var container = document.getElementById(parentId);
        container.scroll({
          top: anchor.offsetTop - scrollOffset,
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var _this2 = this;

      var _this$props5 = this.props,
          parentId = _this$props5.parentId,
          autoScrollOffset = _this$props5.autoScrollOffset,
          getMenuCategoryElements = _this$props5.getMenuCategoryElements;
      var activeItem = this.state.activeItem;

      if (typeof document !== "undefined") {
        var container = document.getElementById(parentId);
        var menuContainer = getMenuCategoryElements(document.getElementById(parentId));
        var scrollPos = menuContainer.scrollTop;
        (0, _toConsumableArray2["default"])(menuContainer.children).forEach(function (child, index) {
          if (index > 0 && child.offsetTop + autoScrollOffset < container.scrollTop && child.offsetTop + child.offsetHeight + autoScrollOffset > container.scrollTop) {
            if (index - 1 !== activeItem) {
              _this2.setState({
                activeItem: index - 1,
                selectedCategory: _this2.getDropdownOptions()[index - 1].value
              });
            }
          }
        });
      }
    }
  }, {
    key: "onSelectCategory",
    value: function onSelectCategory(e, _ref2) {
      var value = _ref2.value;
      this.setState({
        selectedCategory: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          activeItem = _this$state.activeItem,
          selectedCategory = _this$state.selectedCategory;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "food-menu-category-navigation"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu, {
        pointing: true,
        secondary: true,
        className: "desktop"
      }, this.getScheduleCategories().map(function (_ref3, index) {
        var name = _ref3.name;
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, {
          key: name,
          name: name,
          active: index === activeItem || name === activeItem,
          onClick: _this3.onItemClick,
          href: "#".concat(name)
        }, /*#__PURE__*/_react["default"].createElement("h4", null, name));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mobile"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
        onChange: this.onSelectCategory,
        placeholder: "Categories",
        fluid: true,
        selection: true,
        value: selectedCategory,
        options: this.getDropdownOptions()
      })));
    }
  }]);
  return MenuCategoryNavigation;
}(_react["default"].Component);

exports["default"] = MenuCategoryNavigation;
MenuCategoryNavigation.propTypes = {
  scheduleId: _propTypes["default"].number.isRequired,
  schedules: _propTypes["default"].array.isRequired,
  categories: _propTypes["default"].array.isRequired,
  parentId: _propTypes["default"].string.isRequired,
  getMenuCategoryElements: _propTypes["default"].func.isRequired,
  disabledAutoScrollDetection: _propTypes["default"].bool,
  scrollOffset: _propTypes["default"].number,
  autoScrollOffset: _propTypes["default"].number
};
MenuCategoryNavigation.defaultProps = {
  disabledAutoScrollDetection: false,
  scrollOffset: -160,
  autoScrollOffset: 150
};